import type { RSVPSuggestionsFooterProps } from './components/RSVPSuggestionsFooter';
import type { RSVPSuggestionsProps } from './components/RSVPSuggestions';
import type * as lazyIndex from './lazyIndex';
import {
    LazyAction,
    type LazyComponent,
    LazyImport,
    LazyModule,
    createLazyComponent,
} from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import('./lazyIndex'), {
    name: 'common/controls/packages/controls/owa-calendar-rsvp-suggestions',
});

// Components
export const RSVPSuggestions: LazyComponent<RSVPSuggestionsProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.RSVPSuggestions);
export const RSVPSuggestionsFooter: LazyComponent<RSVPSuggestionsFooterProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.RSVPSuggestionsFooter);

//Utils
export const lazyLogRSVPAction: LazyAction<typeof lazyIndex.logRSVPAction, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.logRSVPAction);
export const lazyGetRSVPSuggestions: LazyImport<
    typeof lazyIndex.getRSVPSuggestions,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getRSVPSuggestions);
export const lazyLogExpandCollapseRSVPItemUnifiedTelemetry: LazyAction<
    typeof lazyIndex.logExpandCollapseRSVPItemUnifiedTelemetry,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logExpandCollapseRSVPItemUnifiedTelemetry);
export const lazyRSVPSuggestionsKeyDownHandler: LazyAction<
    typeof lazyIndex.rsvpSuggestionsKeyDownHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.rsvpSuggestionsKeyDownHandler);
export const lazyAutoFocusOnSuggestionOpen: LazyAction<
    typeof lazyIndex.autoFocusOnSuggestionOpen,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.autoFocusOnSuggestionOpen);
export const lazyIsRSVPSuggestionsServiceEnabled: LazyAction<
    typeof lazyIndex.isRSVPSuggestionsServiceEnabled,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isRSVPSuggestionsServiceEnabled);
